<template>
  <div class="review-wrapper">
    <Spin fix size="large" v-show="!isLoaded"></Spin>
    <template v-if="isTryAccount">
      <div class="review-nodata">
        <img src="../../../assets/images/nodata-03.png" alt="无串讲" />
        <br />
        <br />
        <b style="font-size: 16px">试用账号没有有效串讲信息</b>
      </div>
    </template>
    <template v-else>
      <div class="review-nodata" v-show="reviewStatus == -1">
        <img src="../../../assets/images/nodata-03.png" alt="无串讲" />
        <br />
        <br />
        <b style="font-size: 16px">{{ reviewData.t1 }}</b>
        <br />
        <span style="color: #999">{{ reviewData.t2 }}</span>
      </div>
      <!-- 无权限，需要购买 -->
      <div class="review-buy" v-show="reviewStatus == 0">
        <div class="review-name">{{ reviewData.reviewName }}</div>
        <div class="review-remark">
          {{ reviewData.memo }} {{ reviewData.source }}
        </div>
        <div class="review-num">
          视频数：{{ reviewData.pptNum }} 练习题数：{{ reviewData.exerNum }}
        </div>
        <Button type="warning" v-if="reviewData.productId > 0" :to="{}"
          >我要购买</Button
        >
        <Button type="warning" v-else disabled>相关商品已下架，不可购买</Button>
      </div>

      <!-- 课件下载 -->
      <div class="review-ppt-down" style="display: none">
        <Button size="large" icon="ios-download-outline" type="primary"
          >课件下载</Button
        >
      </div>

      <!-- 串讲视频及习题列表 -->
      <!-- <dl class="study-list" v-show="reviewStatus > 0"> -->
      <!-- <dl class="study-list" style="display: none">
        <dt
          class="clearfix"
          :class="{ active: reviewVideoVisible }"
          @click="setVideoVisible"
        >
          <span class="fl">
            {{ reviewVideoList.length }}个串讲视频
            <br />
            <span>视频时长：{{ reviewVideoTotalTime }}分钟</span>
          </span>
          <span class="fr">
            <Icon type="ios-arrow-down" />
          </span>
        </dt>
        <transition name="slide-up">
          <dd v-show="reviewVideoVisible">
            <div v-for="(item, index) in reviewVideoList" :key="index">
              <span class="am-inline-block">
                {{ item.pptName }}
                <br />
                <span>播放次数：{{ item.playTimes }}</span>
              </span>
              <p class="fr">
                <Button
                  type="primary"
                  target="_blank"
                  :to="
                    '/course/reviewvideo?umcid=' +
                    umcId +
                    '&umcrid=' +
                    item.umcrId +
                    '&pptid=' +
                    item.pptId
                  "
                  >播放视频</Button
                >
              </p>
            </div>
          </dd>
        </transition>
      </dl> -->
      <dl class="study-list" v-show="reviewStatus > 0">
        <dt
          class="clearfix"
          :class="{ active: reviewExerciseVisible }"
          @click="setExerciseVisible"
        >
          <span class="fl">
            <img src="../../../assets/images/v3/icon-dot.png" />串讲题/{{
              reviewExerciseList.length
            }}组
            <br />
            <span style="margin-left: 36px"
              >习题数量：{{ reviewExerciseCount }}</span
            >
          </span>
          <span class="fr">
            <Icon custom="ich-icon ich-icon-arraw-down" />
          </span>
        </dt>
        <transition name="slide-up">
          <dd v-show="reviewExerciseVisible">
            <div v-for="(item, index) in reviewExerciseList" :key="index">
              <span class="icon">
                <img src="../../../assets/images/v3/icon-list.png" />
              </span>
              <span>
                {{ item.reviewExerGroupName }}
                <br />
                <span>练习进度：{{ item.progress }}/{{ item.exerNum }}</span>
              </span>
              <p class="fr">
                <Button
                  type="primary"
                  shape="circle"
                  target="_blank"
                  :to="
                    '/course/reviewpractice?umcid=' +
                    reviewUmcId +
                    '&umcrid=' +
                    item.umcrId +
                    '&regid=' +
                    item.reviewExerGroupId
                  "
                  >开始练习</Button
                >
              </p>
            </div>
          </dd>
        </transition>
      </dl>
    </template>
  </div>
</template>
<script>
import { siteMixin } from "../../../utils/mixin";
import { study } from "../../../request";
export default {
  mixins: [siteMixin],
  props: {
    cstId: {
      type: Number,
      default: 0,
    },
    reviewUmcId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoaded: false,
      reviewVideoVisible: false, //班型更改时，已废弃
      reviewExerciseVisible: true,
      isTryAccount: false,
      reviewStatus: -2,
      reviewData: {},
      reviewVideoList: [],
      reviewVideoTotalTime: 0,
      reviewExerciseList: [],
      reviewExerciseCount: 0,
    };
  },
  mounted() {
    if (this.loginUser.ugid == 6) {
      this.isLoaded = true;
      this.isTryAccount = true;
      return;
    }
    this.getReviewInfo();
  },
  methods: {
    async getReviewInfo() {
      const reviewStatus = await study.getReviewStatus(
        this.reviewUmcId,
        this.courseId,
        this.cstId
      );
      //console.log("reviewStatus", reviewStatus);
      if (reviewStatus.status != 1) {
        //this.$Message.error("获取串讲状态失败");
        return;
      }
      this.reviewStatus = reviewStatus.message;
      if (this.reviewStatus == -1) {
        this.reviewData = reviewStatus.data;
      } else if (this.reviewStatus == 0) {
        this.reviewData = reviewStatus.data[0];
      }
      if (this.reviewStatus <= 0) {
        this.isLoaded = true;
        return;
      }
      //获取串讲视频及练习题组
      study.getReviewVideoOrExercisList(this.reviewStatus).then((res) => {
        //study.getReviewVideoOrExercisList(43).then(res => {
        console.log("reviewppt&exercislist", res);
        if (res.status === 1) {
          //this.reviewVideoList = res.data.reviewPptList;
          //this.reviewVideoTotalTime = res.data.pptTimeTotal;
          this.reviewExerciseList = res.data.reviewExerGroupList;
          this.reviewExerciseCount = res.data.reviewExerciseCount;
          // this.reviewVideoTotalTime = res.data.reduce((prev, current) => {
          //   return prev + current.pptTime;
          // }, 0);
          this.isLoaded = true;
        }
      });
    },
    setVideoVisible() {
      this.reviewVideoVisible = !this.reviewVideoVisible;
    },
    setExerciseVisible() {
      this.reviewExerciseVisible = !this.reviewExerciseVisible;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/var.less";
@import "../../../assets/css/study.less";
.review-wrapper {
  width: 100%;
  padding: 0 10px;
  margin-top: -10px;
  position: relative;
  .review-nodata {
    text-align: center;
    padding: 30px 0;
    img {
      .inline-block();
    }
  }
  .review-buy {
    .review-name {
      font-weight: bold;
      font-size: 1.6rem;
    }
    .review-remark {
      padding-top: 10px;
    }
    .review-num {
      margin-bottom: 2rem;
    }
  }
}
</style>